/**
 * Feature flags – set to `true` to enable a feature, `false` to hide it.
 */
export const FEATURES = {
  /** "Tasks" tab in the Statistics page */
  STATS_TASKS_TAB: false,
} as const;
